module.exports = __webpack_public_path__ + "img/shield-bios-banner-01-square.8261257b.jpg";